module.exports = __webpack_public_path__ + "static/media/AtlasGrotesk-Regular-Cy-Web.d07366f9.woff";